import React from 'react';
import { Link } from 'react-router-dom';

export default function EmptyState({
  icon = 'bi-inbox',
  titulo = 'Nenhum registro por aqui',
  texto,
  acaoLabel,
  acaoTo,
  acaoIcon = 'bi-plus-lg',
}) {
  return (
    <div className="sf-empty">
      <span className="sf-empty-icon"><i className={`bi ${icon}`} /></span>
      <span className="sf-empty-title">{titulo}</span>
      {texto && <span className="sf-empty-text">{texto}</span>}
      {acaoLabel && acaoTo && (
        <Link to={acaoTo} className="sf-btn sf-btn-ghost">
          <i className={`bi ${acaoIcon}`} />
          {acaoLabel}
        </Link>
      )}
    </div>
  );
}
